import React from "react";

import { Button, Typography } from "@material-ui/core";

import SvgI24Details from "assets/icons/I24Details";

import TrimmedText from "components/TrimmedText";

import {
  Container,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
} from "./styles";

type Props = {
  title: string;
  onDetailsClick: () => void;
};

class UserCard extends React.Component<Props> {
  render() {
    const { title, onDetailsClick } = this.props;

    return (
      <Container>
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <TrimmedText lines={1} text={title}>
                <Typography variant="h3" color="textPrimary">
                  {title}
                </Typography>
              </TrimmedText>
            </TitleWrapper>
          </TextContainer>
          <BottomControlsContainer>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Details />}
                variant="text"
                color="secondary"
                onClick={onDetailsClick}
              >
                Details
              </Button>
            </ControlWrapper>
          </BottomControlsContainer>
        </DetailsContainer>
      </Container>
    );
  }
}

export default UserCard;
